module.exports = __webpack_public_path__ + "img/preview-mac.894f80d7.png";